const handleCompleteActionFormActions = {
  confirm: 'Do you really want to complete this action?',
  title: 'COMPLETE ACTION',
  newStatus: 'Done',
  inputError: 'A completion message is required'
};

export default handleCompleteActionFormActions;
